/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const CREDIT_UNION_CAN_ABILITY = [
  //Route Access
  ["read", "Profile"],
  ["read", "OrganizationProfile"],
  ["read", "MyProfile"],
  ["read", "ProvisionalPolicies"],
  ["read", "ProvisionalPolicyDetail"],
  ["read", "ActualPolicies"],
  ["read", "ActualPolicyDetails"],
  ["read", "HoldersDetail"],
  ["read", "Holders"],
  ["read", "PolicyDetail"],
  ["read", "Products"],
  ["read", "FHPDetail"],
  ["read", "FHPAnalytics"],
  ["read", "Activity"],
  ["read", "WeatherAnalytics"],
  ["read", "AnalyticsAPIDetail"],
  ["read", "ArchivedPolicyDetail"],
  ["read", "ArchivedPolicies"]
];

export const CREDIT_UNION_CANNOT_ABILITY = [
  //Route Access Denial
  //  ["read", "Button"],
];
